import { useEffect, useState } from 'react';

import { isMobilePhone } from '../utils/devices/device';
import useWindowSize from './useWindowSize';

const getIsHorizontalMobilePhone = (height: number, width: number) => {
  const isHorizontal = height < width;
  return isMobilePhone && isHorizontal;
};

export const useIsHorizontalMobilePhone = (): boolean => {
  const { height, width } = useWindowSize();

  const [isHorizontalMobilePhone, setIsHorizontalMobilePhone] = useState(
    getIsHorizontalMobilePhone(height, width),
  );

  useEffect(() => {
    setIsHorizontalMobilePhone(getIsHorizontalMobilePhone(height, width));
  }, [height, width]);

  return isHorizontalMobilePhone;
};
